/** Bubbling + composed so the parent catches it across the shadow boundary. */
export const OVERLAY_DISMISS_EVENT = 'schmancy-content-drawer-overlay-dismiss'
